// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Stack from "./Stack.res.js";
import * as Title from "../typography/Title.res.js";
import * as React from "react";
import * as TextStyle from "../typography/TextStyle.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function LayoutPanelHeading(props) {
  return JsxRuntime.jsxs(Stack.make, {
    children: [
      JsxRuntime.jsx(Title.make, {
        children: props.title,
        level: 2,
        weight: "bold"
      }),
      JsxRuntime.jsx(TextStyle.make, {
        children: props.description,
        variation: "normal",
        size: "large",
        lineHeight: "large"
      })
    ],
    space: "medium"
  });
}

let make = React.memo(LayoutPanelHeading);

export {
  make,
}
/* make Not a pure module */
